import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  UntypedFormGroup,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import {
  Parameters,
  PledgeProductRead,
} from '@app/forms/subscription/definition/interface/Pledge';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import FormGroupArray from '@app/forms/subscription/services/FormGroupArray';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: PledgeProductRead & { parameters: any }, option) {
    const parameters: Parameters = {
      ...option,
    };
    let options: AbstractControlOptions = {};

    let supportRepartition: UntypedFormGroup[] = [];

    const entitySupportRepartition =
      entity?.parameters?.currentSupportRepartition?.supportRepartition || [];

    if (entitySupportRepartition)
      _.forEach(entitySupportRepartition, (support, i) =>
        supportRepartition.push(
          this.formBuilder.group(this.createModel(support)),
        ),
      );

    const formConfig: FormConfig<PledgeProductRead & { parameters: any }> = {
      id: [entity.id],
      type: [entity.type],
      productId: [entity.productId],
      productName: [entity.productName],
      status: [entity.status],
      parameters: this.formBuilder.group({
        totalAmount: [
          entity?.parameters?.currentSupportRepartition?.totalAmount || null,
        ],
        supportRepartition: this.formBuilder.array(supportRepartition),
      }),
    };

    return this.formBuilder.group(formConfig, options);
  }
  generate(entity: any, option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
      propertyName: 'products',
    });
  }

  public createModel(item) {
    return {
      supportId: [item ? item.supportId : null],
      supportName: [item ? item.supportName : null],
      name: [item ? item.supportName || item.name : null],
      isin: [item ? item.isin : null],
      isr: [item ? item.isr : null],
      amount: [item && !_.isNil(item.amount) ? item.amount : 0],
      percentage: [item ? item.percentage : null],
      supportType: [item ? item.supportType : null],
      index: [item?.index || null],
      perfP3Y: [item?.perfP3Y || null],
      volat3Y: [item?.volat3Y || null],
      risk: [item?.risk || null],
    };
  }

  get products() {
    return this.form.get('products') as UntypedFormArray;
  }
  get supportRepartition() {
    return this.products
      .get(`${0}`)
      .get('parameters')
      .get('supportRepartition') as UntypedFormArray;
  }

  get productId() {
    return this.form.get('products').get(`${0}`).get('productId').value;
  }

  extract() {
    const products = _.cloneDeep(this.form.value.products);
    products.forEach(product => {
      let supportRepartition = _.map(
        _.cloneDeep(product.parameters.supportRepartition),
        support => _.omit(support, ['name']),
      );
      let totalAmount = product.parameters.totalAmount;

      product.parameters.currentSupportRepartition = {
        totalAmount: totalAmount,
        supportRepartition: supportRepartition,
      };
      product.parameters.totalAmount = undefined;
    });
    return products;
  }
}
